// extracted by mini-css-extract-plugin
export var active = "_gg-2";
export var recordingDot = "_gg-1";
export var recordingIndicator = "_gg-0";